export const pickingMockData = {
  uph_picking: {
    current: 115,
    trendWindow: 'P28D',
    trendData: [
      110, 111, 112, 113, 113, 114, 114, 115, 115, 115, 116, 116, 116, 117, 117,
      117, 116, 116, 115, 115, 115, 114, 114, 113, 113, 112, 111, 110,
    ],
    forecastHorizon: 'P7D',
    forecast: [116, 117, 117, 118, 118, 119, 120],
    trend: 'up',
    status: 'good',
    unit: 'units/hr',
    label: 'Units Per Hour (Picking)',
    variableValues: {
      includeTravel: true,
      pickingMethod: 'all',
      timeWindow: 'P28D',
    },
    relatedData: {
      replenishment_rate: {
        correlation: 0.82,
        trend: 'up',
        current: 28,
      },
      avg_lines_per_order: {
        correlation: 0.71,
        trend: 'stable',
        current: 4.8,
      },
      average_distance: {
        correlation: -0.55,
        trend: 'down',
        current: 4.2,
      },
    },
    currentVisualization: 'line',
  },
  picking_accuracy: {
    current: 99.6,
    trendWindow: 'P28D',
    trendData: [
      99.2, 99.3, 99.3, 99.4, 99.4, 99.5, 99.5, 99.6, 99.6, 99.6, 99.7, 99.7,
      99.7, 99.6, 99.6, 99.6, 99.5, 99.5, 99.4, 99.4, 99.3, 99.3, 99.2, 99.2,
      99.3, 99.4, 99.5, 99.6,
    ],
    forecastHorizon: 'P7D',
    forecast: [99.7, 99.7, 99.7, 99.8, 99.8, 99.8, 99.8],
    trend: 'up',
    status: 'good',
    unit: '%',
    label: 'Picking Accuracy',
    variableValues: {
      errorType: 'all',
      timeWindow: 'P28D',
    },
    relatedData: {
      uph_picking: {
        correlation: -0.45,
        trend: 'up',
        current: 115,
      },
      avg_weight_per_line: {
        correlation: 0.38,
        trend: 'stable',
        current: 1.8,
      },
      avg_volume_per_line: {
        correlation: 0.42,
        trend: 'stable',
        current: 0.009,
      },
    },
    currentVisualization: 'gauge',
  },
  average_picking_time: {
    current: 2.3,
    trendWindow: 'P28D',
    trendData: [
      2.5, 2.5, 2.4, 2.4, 2.4, 2.3, 2.3, 2.3, 2.2, 2.2, 2.2, 2.3, 2.3, 2.3, 2.4,
      2.4, 2.4, 2.3, 2.3, 2.3, 2.2, 2.2, 2.2, 2.3, 2.3, 2.3, 2.4, 2.3,
    ],
    forecastHorizon: 'P7D',
    forecast: [2.2, 2.2, 2.1, 2.1, 2.0, 2.0, 1.9],
    trend: 'down',
    status: 'good',
    unit: 'min',
    label: 'Average Picking Time',
    variableValues: {
      timeWindow: 'P28D',
    },
    currentVisualization: 'line',
  },
  average_distance: {
    current: 4.2,
    trendWindow: 'P28D',
    trendData: [
      4.5, 4.5, 4.4, 4.4, 4.3, 4.3, 4.2, 4.2, 4.1, 4.1, 4.2, 4.2, 4.3, 4.3, 4.4,
      4.4, 4.5, 4.5, 4.4, 4.4, 4.3, 4.3, 4.2, 4.2, 4.1, 4.1, 4.2, 4.2,
    ],
    forecastHorizon: 'P7D',
    forecast: [4.1, 4.0, 4.0, 3.9, 3.9, 3.8, 3.8],
    trend: 'down',
    status: 'good',
    unit: 'm',
    label: 'Average Distance',
    variableValues: {
      timeWindow: 'P28D',
    },
    currentVisualization: 'line',
  },
  order_job_line_cascade: {
    current: 0.78,
    trendWindow: 'P28D',
    trendData: [
      0.75, 0.76, 0.76, 0.77, 0.77, 0.78, 0.78, 0.79, 0.79, 0.79, 0.78, 0.78,
      0.77, 0.77, 0.76, 0.76, 0.77, 0.77, 0.78, 0.78, 0.78, 0.79, 0.79, 0.8,
      0.8, 0.79, 0.79, 0.78,
    ],
    forecastHorizon: 'P7D',
    forecast: [0.79, 0.79, 0.8, 0.8, 0.81, 0.81, 0.82],
    trend: 'up',
    status: 'good',
    unit: 'correlation',
    label: 'Order-Job-Line Cascade Efficiency',
    cascadeData: {
      order_count: 125,
      job_count: 42,
      line_count: 587,
      lines_per_order: 4.7,
      lines_per_job: 14.0,
      jobs_per_order: 0.34,
      travel_efficiency: 0.78,
    },
    variableValues: {
      cascadeLevel: 'all',
      timeWindow: 'P28D',
    },
    currentVisualization: 'sankey',
  },
  item_profile_picking_effect: {
    current: -0.65,
    trendWindow: 'P28D',
    trendData: [
      -0.6, -0.61, -0.62, -0.63, -0.63, -0.64, -0.64, -0.65, -0.65, -0.65,
      -0.66, -0.66, -0.65, -0.65, -0.64, -0.64, -0.63, -0.63, -0.64, -0.64,
      -0.65, -0.65, -0.66, -0.66, -0.67, -0.66, -0.66, -0.65,
    ],
    forecastHorizon: 'P7D',
    forecast: [-0.64, -0.64, -0.63, -0.63, -0.62, -0.62, -0.61],
    trend: 'up',
    status: 'good',
    unit: 'correlation',
    label: 'Item Profile Impact',
    profileData: {
      weight_impact: -0.58,
      volume_impact: -0.65,
      fragility_impact: -0.42,
      handling_complexity_impact: -0.71,
    },
    variableValues: {
      profileAttribute: 'all',
      timeWindow: 'P28D',
    },
    currentVisualization: 'scatter',
  },
};

export default pickingMockData;
